import validate from "/var/lib/jenkins/workspace/Website Frontend - Production/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/var/lib/jenkins/workspace/Website Frontend - Production/middleware/redirects.global.js";
import manifest_45route_45rule from "/var/lib/jenkins/workspace/Website Frontend - Production/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-redirect": () => import("/var/lib/jenkins/workspace/Website Frontend - Production/middleware/authRedirect.js"),
  "trailing-slash": () => import("/var/lib/jenkins/workspace/Website Frontend - Production/middleware/trailingSlash.js"),
  "sidebase-auth": () => import("/var/lib/jenkins/workspace/Website Frontend - Production/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}